import { Button, Modal } from "@material-ui/core";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as CancelBtn } from "assets/Cancel.svg";
import clsx from "clsx";
import { t } from "i18next";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React from "react";
import Scrollbar from "react-scrollbars-custom";
import { List, useStylesForMetadataPopup } from "./MetaView";
const dateFormatter = (str: string, key: string) => {
  const date = new Date(str);
  if (
    !key.toLowerCase().includes("date") ||
    date.toString() === "Invalid Date"
  ) {
    return str;
  }
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};
function MetadataView({
  open,
  meaId,
  rtl,
  setOpen,
  metaData,
  onEdit,
  disableEdit,
}: {
  open: boolean;
  meaId: string;
  rtl: boolean;
  setOpen: any;
  metaData: any;
  disableEdit: boolean;
  onEdit: (meaId: string) => void;
}) {
  // the modal code, can be found in client\src\cms\components\view\MetaView.tsx , line 227
  const modalStyles = useStylesForMetadataPopup(rtl);
  const metaValues =
    metaData["Localized-Text-Attributes"][rtl ? "ar" : "en-gb"];
  const sortBy =
    metaData["Localized-Text-Attributes"]["Attributes-Order"] || [];
  const ctx = useAppContext();
  const getMetaDataItems = () => {
    const items: { [key: string]: any } = {};
    Object.keys(metaData).forEach((key) => {
      if (
        ![
          "Foreign-Keys",
          "Localized-Text-Attributes",
          "Attributes-Order",
        ].includes(key)
      ) {
        const data = dateFormatter(metaData[key], key);
        items[key] = data;
      }
    });
    const foreignKey = metaData["Foreign-Keys"] || {};
    return { ...items, ...foreignKey };
  };

  const metaDataForeignValues = getMetaDataItems();
  const metadataKeys = Object.keys(metaValues);

  const metaDataForeignKeys = Object.keys(metaDataForeignValues);
  return (
    <Modal
      open={open}
      dir={rtl ? "rtl" : "ltr"}
      style={{
        zIndex: 99999,
        display: "flex",
        justifyContent: "flex-start",
        backgroundColor: "white",
        width: "85vw",
        height: "85vh",
        top: "10vh",
        left: "7.5vw",
        right: "7.5vw",
        borderRadius: "25px",
      }}
      className={modalStyles.Modal}
      onClose={() => {
        setOpen(false);
      }}
    >
      <div style={{ width: "100%", background: "white", borderRadius: "25px" }}>
        <div className={modalStyles.ModalContainer2}>
          <div className={modalStyles.HeaderRow2}>
            <div className={modalStyles.HeaderLeft}>
              <div
                role="button"
                tabIndex={0}
                className={modalStyles.IconContainer}
                onKeyDown={() => {}}
                onClick={() => {
                  setOpen(false);
                }}
                style={{
                  width: "48px",
                  height: "48px",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "50%",
                  justifyContent: "center",
                  backgroundColor: "rgb(0,169,163)",
                }}
              >
                <DescriptionOutlinedIcon
                  style={{
                    width: "1.333em",
                    transform: "scale(1.5)",
                    height: "1.666em",
                    color: "white",
                  }}
                  className={modalStyles.Icon}
                />
                {/* )} */}
              </div>
              <div
                className={clsx(modalStyles.Header, "DinNextLTArabic")}
                style={{
                  color: "rgb(17,94,103)",
                  fontSize: "16px",
                  marginLeft: ctx.rtl ? undefined : "1.142em",
                  marginRight: ctx.rtl ? "1.142em" : undefined,
                }}
              >
                {t("Metadata")}
              </div>
            </div>
            <div className={modalStyles.buttons}>
              <Button
                onClick={() => onEdit(meaId)}
                disabled={disableEdit}
                className={modalStyles.editBtn}
              >
                <EditOutlinedIcon />
                <span>{t("Edit")}</span>
              </Button>
              <CancelBtn
                className={modalStyles.IconClose}
                onClick={() => setOpen(false)}
              />
            </div>
          </div>

          <div style={{ height: "100%" }}>
            <Scrollbar
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              <div className={modalStyles.PropsArea}>
                <table width="100%" style={{ borderCollapse: "collapse" }}>
                  <tbody>
                    <List
                      keys={[...metaDataForeignKeys, ...metadataKeys]}
                      data={{ ...metaValues, ...metaDataForeignValues }}
                      sortBy={sortBy}
                      classes={[modalStyles.rowText, modalStyles.rowValue]}
                    />
                  </tbody>
                </table>
              </div>
            </Scrollbar>
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default MetadataView;
